export default __webpack_public_path__ + "static/ANDREATTA-LOGO-2021-FINALS-02-947448ceff0ca97ad6551870d0413e86.png";